import {navigationService} from 'Application/services/NavigationService';

/**
 * A custom hook that retrieves the current section from the navigation service.
 * This hook provides access to the currently active section in the application's navigation state.
 * It serves as a convenient way to access navigation state without directly importing the navigation service.
 *
 * @returns The current section value from the navigation service.
 *
 * @example
 * ```tsx
 * const MyComponent = () => {
 *   const currentSection = useCurrentSection();
 *
 *   return (
 *     <div>
 *       Current section: {currentSection}
 *     </div>
 *   );
 * };
 * ```
 */
export const useCurrentSection = () => ({currentSection: navigationService.currentSection});